import { render, staticRenderFns } from "./impacto-social.vue?vue&type=template&id=5a2243ec&scoped=true"
import script from "./impacto-social.vue?vue&type=script&lang=js"
export * from "./impacto-social.vue?vue&type=script&lang=js"
import style0 from "./impacto-social.vue?vue&type=style&index=0&id=5a2243ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2243ec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderMain: require('/builds/marketing/abstracta.academy-website/components/HeaderMain.vue').default})
